import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './utils/pwa';
import './utils/saudiRiyalSymbol.css';
import '@emran-alhaddad/saudi-riyal-font/index.css';

// Essential PWA setup only - minimal for fast loading
registerServiceWorker();

// Vite dynamic import chunk error recovery
// When a new deployment occurs, older chunk hashes no longer exist on the server.
// Listening to 'vite:preloadError' automatically reloads the page to fetch the new manifest.
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Vite preload error encountered; reloading application to fetch latest deployment manifest...', event);
  const lastReload = sessionStorage.getItem('vite_chunk_reload_ts');
  const now = Date.now();
  if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
    sessionStorage.setItem('vite_chunk_reload_ts', now.toString());
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

